import {bp} from '../core/namespace.js';

export let triggerRedirect = false;
export const zoomLevelToShowBrokerMarkers = 12;
export function landingPageRedirectRules(){
  /**
   * URL must only be changed if the filter applied changes the current page.
   * In reality, this is just a cosmetic change, we are only pushing url onto the stack
   * under the hood it works the same way.
   *
   * Moving map box not checked, search in place [no trigger]
   * City - > redirect if city is applied [set trigger]
   * City/Useplan - > redirect if city/useplan is applied [set trigger]
   * Gemente - > redirect if any filter is applied [set trigger]
   * Polygon circle on any page move to new page
   *
   * Page types by url name
   *  "geo-region_detail" -> detail page
   *  "geo-province_detail" -> province detail page
   *  "geo-city_detail": -> city landing page
   *  "geo-city_landingpage_detail" -> city useplan landing page
   *  "geo-community_detail" -> community landing page
   *  "geo-businesspark_detail" -> businesspark landing page
   */
   try{
      var auxBack = performance.getEntriesByType("navigation");
      if (auxBack[0].type === "back_forward") {
          //location.reload(true);
        console.debug("back")
      }
    } catch(e){
     console.debug(e)
   }

  const formId = bp.bootstrap.get_bootstrap_environment() === 'lg' ? 'search_data' : 'search_data_modal'
  let pageType = undefined
  try{
    pageType = document.getElementById(formId).dataset.urlname
  } catch(e){
     console.debug(e)
  }


  console.debug(`pageType: ${pageType}`)
  window.addEventListener('cityfieldchanged', ()=> console.debug('cityfieldchanged'))
  window.addEventListener('useplanchanged', ()=> console.debug('useplanchanged'))
  window.addEventListener('movementCheckboxSet', ()=> console.debug('movementCheckboxSet'))

   window.addEventListener('mapShapeDrawingComplete',  ()=> triggerRedirect = true)

   if(pageType === "geo-city_landingpage_detail"){
      window.addEventListener('cityfieldchanged', ()=> triggerRedirect = true)
      window.addEventListener('useplanchanged', ()=> triggerRedirect = true)
      window.addEventListener('movementCheckboxSet', () => triggerRedirect = true)
   }

   if(pageType === "geo-useplan_detail"){
      window.addEventListener('useplanchanged', ()=> triggerRedirect = true)
      window.addEventListener('movementCheckboxSet', () => triggerRedirect = true)
   }

   if(pageType === "geo-city_detail"){
      window.addEventListener('cityfieldchanged', () => triggerRedirect = true)
      window.addEventListener('movementCheckboxSet', () => triggerRedirect = true)
   }

   if(pageType === "geo-region_detail" || pageType === "geo-province_detail" ||
     pageType === "geo-community_detail" || pageType === "geo-businesspark_detail"){
      window.addEventListener('movementCheckboxSet', () => triggerRedirect = true)
   }
}
